function stableBvhUrlIdentity(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) {
    return '';
  }

  try {
    return new URL(trimmed).pathname;
  } catch {
    return trimmed.split('?')[0]?.split('#')[0] ?? trimmed;
  }
}

export function buildBvhUrlsIdentity(urls: readonly string[]): string {
  return urls.map(stableBvhUrlIdentity).join('\0');
}

export function resolvedSequenceMatchesRequestedSource(
  requestedUrls: readonly string[],
  loadedUrls: readonly string[],
) {
  return (
    requestedUrls.length > 0 &&
    loadedUrls.length === requestedUrls.length &&
    buildBvhUrlsIdentity(loadedUrls) === buildBvhUrlsIdentity(requestedUrls)
  );
}
